// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-animal-controls {
  height: 100%;
}
app-animal-controls > .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  flex-flow: column;
}
app-animal-controls > .container > .inner-container {
  display: inline-flex;
  justify-content: center;
  flex-flow: column;
}
app-animal-controls > .container > .inner-container > .controls {
  display: flex;
  justify-content: center;
}
app-animal-controls > .container > .inner-container > .controls > .control {
  cursor: pointer;
  margin-left: 8px;
  margin-right: 8px;
}
app-animal-controls > .container > .inner-container > .controls > .control.arrow {
  background: #FFFFFF;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);
}
app-animal-controls > .container > .inner-container > .controls > .control.arrow.left {
  margin-right: 50px;
}
app-animal-controls > .container > .inner-container > .controls > .control.arrow.left mat-icon {
  margin-right: 4px;
}
app-animal-controls > .container > .inner-container > .controls > .control.arrow.right {
  margin-left: 50px;
}
app-animal-controls > .container > .inner-container > .controls > .control.arrow.right mat-icon {
  margin-left: 4px;
}
app-animal-controls > .container > .inner-container > .controls > .control.arrow path {
  fill: rgb(0, 138, 156);
}
app-animal-controls > .container > .inner-container > .controls > .control.set-avatar {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  font-weight: 500;
  color: #fff;
  position: relative;
  background: rgba(255, 255, 255, 0.5);
  border: 2px solid #EC6602;
}
app-animal-controls > .container > .inner-container > .controls > .control.set-avatar path {
  fill: #EC6602;
}
app-animal-controls > .container > .inner-container > .controls > .control.set-avatar > .avatar-default {
  display: none;
}
app-animal-controls > .container > .inner-container > .controls > .control.set-avatar.selected {
  background: rgba(236, 102, 2, 0.8);
  border: none;
}
app-animal-controls > .container > .inner-container > .controls > .control.set-avatar.selected path {
  fill: #fff;
}
app-animal-controls > .container > .inner-container > .controls > .control.set-avatar.selected > .avatar-default {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -6px;
  right: -6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  width: 24px;
  height: 24px;
}
app-animal-controls > .container > .inner-container > .controls > .control.set-avatar.selected > .avatar-default mat-icon {
  min-height: unset;
  min-width: unset;
  height: 18px;
  width: 18px;
  font-size: 18px;
}
app-animal-controls > .container > .inner-container > .controls > .control.set-avatar.selected > .avatar-default mat-icon path {
  fill: #81B52B;
}
app-animal-controls > .container > .inner-container > .controls > .control.disabled {
  opacity: 0.3;
  cursor: unset;
}
app-animal-controls > .container > .inner-container > .controls .name {
  background: rgba(211, 216, 0, 0.7);
  border-radius: 100px;
  font-weight: 500;
  font-size: 24px;
  text-align: center;
  color: #FFFFFF;
  margin-left: 8px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  font-family: Roboto;
}
app-animal-controls > .container > .inner-container > .controls .name > .text {
  margin: 0 40px;
}
app-animal-controls > .container > .inner-container > .controls .name > input {
  background: none;
  color: #fff;
  text-align: center;
  margin: 0 40px;
  border-bottom: 1px solid #fff;
  font-family: Roboto;
}
app-animal-controls > .container > .inner-container > .controls .name > .edit {
  font-size: 16px;
  margin-right: 8px;
  cursor: pointer;
}
app-animal-controls > .container > .inner-container > .controls .name > .edit.check {
  border: 1px solid #fff;
  border-radius: 50%;
  height: 24px;
  width: 24px;
}
app-animal-controls > .container > .inner-container > .controls .name > .edit.disabled {
  opacity: 0.3;
  cursor: unset;
}
app-animal-controls > .container > .inner-container > .controls .name > .edit mat-icon svg {
  height: 18px;
}
app-animal-controls > .container > .inner-container > .controls .name > .edit mat-icon svg path {
  fill: none;
}
app-animal-controls > .container > .inner-container .xp-bar-container {
  display: flex;
  flex-flow: column;
  padding-left: 66px;
  padding-right: 66px;
}
app-animal-controls > .container > .inner-container .xp-bar-container .label {
  color: #FFFFFF;
  font-weight: 500;
}
app-animal-controls > .container > .inner-container .xp-bar-container .bar-container {
  width: 100%;
  height: 10px;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 100px;
}
app-animal-controls > .container > .inner-container .xp-bar-container .bar {
  background: linear-gradient(to right, red, yellow, green);
  height: 10px;
  border-radius: 100px;
}
app-animal-controls .popup-container {
  flex: 1;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  width: 100%;
}
app-animal-controls .popup-container app-accessories-popup {
  height: 100%;
  justify-self: flex-start;
  width: 100%;
}
app-animal-controls path {
  fill: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/@modules/gamification/core/animal-controls/animal-controls.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AACI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AACR;AACQ;EACI,oBAAA;EACA,uBAAA;EACA,iBAAA;AACZ;AACY;EACI,aAAA;EACA,uBAAA;AAChB;AACgB;EACI,eAAA;EAEA,gBAAA;EACA,iBAAA;AAApB;AAEoB;EACI,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iDAAA;AAAxB;AAEwB;EACI,kBAAA;AAA5B;AAE4B;EACI,iBAAA;AAAhC;AAIwB;EACI,iBAAA;AAF5B;AAI4B;EACI,gBAAA;AAFhC;AAMwB;EACI,sBAAA;AAJ5B;AAQoB;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;AANxB;AAQwB;EACI,aAAA;AAN5B;AASwB;EACI,aAAA;AAP5B;AAUwB;EACI,kCAAA;EACA,YAAA;AAR5B;AAU4B;EACI,UAAA;AARhC;AAW4B;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;AAThC;AAWgC;EACI,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AATpC;AAWoC;EACI,aAAA;AATxC;AAiBoB;EACI,YAAA;EACA,aAAA;AAfxB;AAmBgB;EACI,kCAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAjBpB;AAmBoB;EACI,cAAA;AAjBxB;AAqBoB;EACI,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;EACA,mBAAA;AAnBxB;AAsBoB;EACI,eAAA;EACA,iBAAA;EACA,eAAA;AApBxB;AAsBwB;EACI,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AApB5B;AAuBwB;EACI,YAAA;EACA,aAAA;AArB5B;AAyB4B;EACI,YAAA;AAvBhC;AAyBgC;EACI,UAAA;AAvBpC;AA+BY;EACI,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AA7BhB;AA+BgB;EACI,cAAA;EACA,gBAAA;AA7BpB;AAgCgB;EACI,WAAA;EACA,YAAA;EACA,0CAAA;EACA,oBAAA;AA9BpB;AAiCgB;EACI,yDAAA;EACA,YAAA;EACA,oBAAA;AA/BpB;AAqCI;EACI,OAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EAEA,WAAA;AApCR;AAsCQ;EACI,YAAA;EACA,wBAAA;EACA,WAAA;AApCZ;AAyCI;EACI,UAAA;AAvCR","sourcesContent":["app-animal-controls {\r\n    height: 100%;\r\n\r\n    >.container {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        height: 100%;\r\n        flex-flow: column;\r\n\r\n        >.inner-container {\r\n            display: inline-flex;\r\n            justify-content: center;\r\n            flex-flow: column;\r\n\r\n            >.controls {\r\n                display: flex;\r\n                justify-content: center;\r\n\r\n                >.control {\r\n                    cursor: pointer;\r\n\r\n                    margin-left: 8px;\r\n                    margin-right: 8px;\r\n\r\n                    &.arrow {\r\n                        background: #FFFFFF;\r\n                        height: 50px;\r\n                        width: 50px;\r\n                        border-radius: 50%;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        justify-content: center;\r\n                        box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);\r\n\r\n                        &.left {\r\n                            margin-right: 50px;\r\n\r\n                            mat-icon {\r\n                                margin-right: 4px;\r\n                            }\r\n                        }\r\n\r\n                        &.right {\r\n                            margin-left: 50px;\r\n\r\n                            mat-icon {\r\n                                margin-left: 4px;\r\n                            }\r\n                        }\r\n\r\n                        path {\r\n                            fill: rgb(0, 138, 156);\r\n                        }\r\n                    }\r\n\r\n                    &.set-avatar {\r\n                        height: 50px;\r\n                        width: 50px;\r\n                        border-radius: 50%;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        justify-content: center;\r\n                        font-size: 30px;\r\n                        font-weight: 500;\r\n                        color: #fff;\r\n                        position: relative;\r\n                        background: rgba(255, 255, 255, 0.5);\r\n                        border: 2px solid #EC6602;\r\n\r\n                        path {\r\n                            fill: #EC6602;\r\n                        }\r\n\r\n                        >.avatar-default {\r\n                            display: none;\r\n                        }\r\n\r\n                        &.selected {\r\n                            background: rgba(236, 102, 2, 0.8);\r\n                            border: none;\r\n\r\n                            path {\r\n                                fill: #fff\r\n                            }\r\n\r\n                            >.avatar-default {\r\n                                display: flex;\r\n                                align-items: center;\r\n                                justify-content: center;\r\n                                position: absolute;\r\n                                top: -6px;\r\n                                right: -6px;\r\n                                border-radius: 50%;\r\n                                background: rgba(255, 255, 255, 0.9);\r\n                                width: 24px;\r\n                                height: 24px;\r\n\r\n                                mat-icon {\r\n                                    min-height: unset;\r\n                                    min-width: unset;\r\n                                    height: 18px;\r\n                                    width: 18px;\r\n                                    font-size: 18px;\r\n\r\n                                    path {\r\n                                        fill: #81B52B;\r\n                                    }\r\n                                }\r\n                            }\r\n                        }\r\n\r\n                    }\r\n\r\n                    &.disabled {\r\n                        opacity: 0.3;\r\n                        cursor: unset;\r\n                    }\r\n                }\r\n\r\n                .name {\r\n                    background: rgba(211, 216, 0, 0.7);\r\n                    border-radius: 100px;\r\n                    font-weight: 500;\r\n                    font-size: 24px;\r\n                    text-align: center;\r\n                    color: #FFFFFF;\r\n                    margin-left: 8px;\r\n                    margin-right: 8px;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    font-family: Roboto;\r\n\r\n                    >.text {\r\n                        margin: 0 40px;\r\n\r\n                    }\r\n\r\n                    >input {\r\n                        background: none;\r\n                        color: #fff;\r\n                        text-align: center;\r\n                        margin: 0 40px;\r\n                        border-bottom: 1px solid #fff;\r\n                        font-family: Roboto;\r\n                    }\r\n\r\n                    >.edit {\r\n                        font-size: 16px;\r\n                        margin-right: 8px;\r\n                        cursor: pointer;\r\n\r\n                        &.check {\r\n                            border: 1px solid #fff;\r\n                            border-radius: 50%;\r\n                            height: 24px;\r\n                            width: 24px;\r\n                        }\r\n\r\n                        &.disabled {\r\n                            opacity: 0.3;\r\n                            cursor: unset;\r\n                        }\r\n\r\n                        mat-icon {\r\n                            svg {\r\n                                height: 18px;\r\n\r\n                                path {\r\n                                    fill: none;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n            .xp-bar-container {\r\n                display: flex;\r\n                flex-flow: column;\r\n                padding-left: 66px;\r\n                padding-right: 66px;\r\n\r\n                .label {\r\n                    color: #FFFFFF;\r\n                    font-weight: 500;\r\n                }\r\n\r\n                .bar-container {\r\n                    width: 100%;\r\n                    height: 10px;\r\n                    background-color: rgba(255, 255, 255, 0.7);\r\n                    border-radius: 100px;\r\n                }\r\n\r\n                .bar {\r\n                    background: linear-gradient(to right, red, yellow, green);\r\n                    height: 10px;\r\n                    border-radius: 100px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .popup-container {\r\n        flex: 1;\r\n        display: flex;\r\n        align-items: flex-end;\r\n        overflow: hidden;\r\n\r\n        width: 100%;\r\n\r\n        app-accessories-popup {\r\n            height: 100%;\r\n            justify-self: flex-start;\r\n            width: 100%;\r\n        }\r\n\r\n    }\r\n\r\n    path {\r\n        fill: #fff;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
